
import {
  FETCH_TASK_TITLES_REQUEST,
  FETCH_TASK_TITLES_SUCCESS,
  FETCH_TASK_TITLES_FAILURE,
  CREATE_TASK_TITLE_REQUEST,
  CREATE_TASK_TITLE_SUCCESS,
  CREATE_TASK_TITLE_FAILURE,
} from "../actions/tasksTitleActions";

const initialState = {
  taskTitles: [],
  loading: false,
  error: null,
  creating: false, // For create action loader
};

const tasksTitleReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TASK_TITLES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_TASK_TITLES_SUCCESS:
      return { ...state, loading: false, taskTitles: action.payload };

    case FETCH_TASK_TITLES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_TASK_TITLE_REQUEST:
      return { ...state, creating: true, error: null };

    case CREATE_TASK_TITLE_SUCCESS:
      return { ...state, creating: false };

    case CREATE_TASK_TITLE_FAILURE:
      return { ...state, creating: false, error: action.payload };

    default:
      return state;
  }
};

export default tasksTitleReducer;
